import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'subrecipients',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Subrecipients',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Subrecipients',
    page: { alias: 'sr:subrecipients' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
